export default "/_next/static/images/Wire-4-ce43bf6dfdf53f25984d7fb7bcf12bda.svg";